import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { loading } from './actions';

export interface LoadingState {
  isLoading: boolean
};

const initialState: LoadingState = {
  isLoading: false
};

const reducer = reducerWithInitialState(initialState)
  .case(loading.started, () => {
    return { isLoading: true };
  })
  .case(loading.done, () => {
    return { isLoading: false };
  })
  .case(loading.failed, () => {
    return { isLoading: false };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/loading/reducers.ts